import angular from 'angular';
import kformUtils from '../../utils/kform-utils';
import template from './textarea.html';
import TextareaComponent from './textarea.component';

const textareaConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('textarea', {
		title:                          'Text Area',
		template,
		controller:     /* @ngInject */ (/** @type {any} */ $scope) => {
			$scope.changeValue = () => {
				if (typeof $scope.component.event.onChange === 'function') {
					const custom = ''.concat($scope.component.event.onChange, '; ');
					kformUtils.evaluate(custom, {
						data: $scope.data,
						form: $scope.form,
					});
				}
			};
		},
		children:                       false,
		selectable:                     true,
		settings:                       new TextareaComponent(),
		icon:                           'fa fa-font',
		views:                          [
			{
				name:     'Display',
				template: 'kform/components/textarea/display.html',
			},
			{
				name:     'Data',
				template: 'kform/components/textarea/data.html',
			},
			{
				name:     'Validation',
				template: 'kform/components/textfield/validate.html',
			},
			{
				name:     'API',
				template: 'kform/components/common/api.html',
			},
			{
				name:     'Layout',
				template: 'kform/components/common/layout.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
			{
				name:     'Events',
				template: 'kform/components/common/events.html',
			},
		],
	});
};

export default angular.module('app')
	.config(textareaConfig);
